import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
  readonly JRCC_TABLE_IDS = [
    '947cfc88-b9c4-453b-8f50-05a9ca6654ac',
    '47535aed-9bc3-4380-9f9e-7ec90c4e5a14'
  ];
  // Restaurants where the rescan session timer is disabled
  readonly RESCAN_TIMER_DISABLED_RESTAURANT_IDS = [
    '2d7ff2b2-1f92-4e5c-91ef-0b78d4a62340', // Westin
    'e01d069a-0a1d-4de6-8a2f-bf140789dbe0', // Elite
    '267103e3-b937-4212-8ce6-f6457082c7e4',
    '38697545-f2a0-4649-a376-f8015dcfe5bf',
  ];
  readonly LOCAL_DEV_TABLE_ID = 'fd17dd02-09d7-4c7c-809c-3be7d8e6869c';
}